// extracted by mini-css-extract-plugin
export default {"text":"lvBGWOOW_Cmy2icV941A","archivedRow":"K_yInwOBhc6tdt6Py2gz","tableWrapper":"zPx2CdeUlo66q5jHTev0"};